module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amos Oz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amos Oz was born in Jerusalem in 1939. He is the author of twenty novels and collections of short fiction, and ten works of nonfiction. His acclaimed memoir "), _c('I', [_vm._v("A Tale of Love and Darkness")]), _vm._v(" was an international bestseller and recipient of the prestigious Goethe Prize, as well as the National Jewish Book Award. "), _c('I', [_vm._v("Scenes from Village Life")]), _vm._v(", a New York Times Notable Book, was awarded the Prix Méditerranée Étranger in 2010. Oz lives in Tel Aviv, Israel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4TwQsC/tc-custom/9780547563886.jpg?1734284468466",
      "alt": "This image is the cover for the book Hill of Evil Counsel"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hill of Evil Counsel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three stories of “sensuous prose and indelible imagery” that re-create the world of Jerusalem during the last days of the British Mandate ("), _c('i', [_vm._v("The New York Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Refugees drawn to Jerusalem in search of safety are confronted by activists relentlessly preparing for an uprising, oblivious to the risks. Meanwhile, a wife abandons her husband, and a dying man longs for his departed lover. Among these characters lives a boy named Uri, a friend and confidant of several conspirators who love and humor him as he weaves in and out of all three stories. "), _c('i', [_vm._v("The Hill of Evil Counsel")]), _vm._v(" is “as complex, vivid, and uncompromising as Jerusalem itself” ("), _c('i', [_vm._v("The Nation")]), _vm._v(")."), _c('br'), _c('br'), _vm._v(" “Oz evokes Israeli life with the same sly precision with which Chekhov evoked pre-Revolutionary Russian life.” —"), _c('i', [_vm._v("Los Angeles Times")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0